module.exports = __webpack_public_path__ + "static/media/combined_mockup.cec421a8.png";